import React, { Component } from 'react';
import { T } from '../../../../../common/locale/translate';
import { MAP_STYLES } from './../../../common/map/map_styles';
import { MAP_API_URL } from './../../../common/map/api_urls';

export default class OfferMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zoomFactor: 16,
      hasMapTypeControl: false,
      offerCoordinates: {
        lat: this.props.coordinates.latitude,
        lng: this.props.coordinates.longitude
      },
      wasMapOpen: false
    };
    this.initMap = this.initMap.bind(this);
    this.openMap = this.openMap.bind(this);
  }

  render = () => (
    <div>
      <div className="offer-map" ref="map">
        {T('hotel_placement_map')}
      </div>
    </div>
  );

  loadGoogleMap = () => {
    window.initMap = this.initMap;
    this.loadApiScript(MAP_API_URL);
  };

  initMap = () => {
    let map = new google.maps.Map(this.refs.map, {
      center: this.state.offerCoordinates,
      zoom: this.state.zoomFactor,
      mapTypeControl: this.state.hasMapTypeControl,
      styles: MAP_STYLES
    });

    new google.maps.Marker({
      position: this.state.offerCoordinates,
      map: map
    });
  };

  loadApiScript = src => {
    let ref = window.document.getElementsByTagName('script')[0];
    let script = window.document.createElement('script');
    script.src = src;
    script.async = true;
    ref.parentNode.insertBefore(script, ref);
  };

  openMap = () => {
    if (this.state.wasMapOpen) {
      return;
    }
    this.setState({ wasMapOpen: true }, this.loadGoogleMap());
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/offer_map.jsx